function n(e) {
  return e === null ? NaN : +e;
}
function* f(e, l) {
  for (let u of e)
    u != null && (u = +u) >= u && (yield u);
}
export {
  n as default,
  f as numbers
};
